export default "/images/bc281adf8e6743b5de305a0d50fbc77c.avif";